// extracted by mini-css-extract-plugin
export default {"wrapper":"Box_wrapper__WFjiS","title":"Box_title__8ulqb"};